import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Lock, AlertCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    document.title = 'Admin | Powerlab Works';
    const m = document.createElement('meta');
    m.name = 'robots';
    m.content = 'noindex,nofollow';
    m.setAttribute('data-admin-noindex', 'true');
    document.head.appendChild(m);
    // Redirect if already authenticated
    const token = localStorage.getItem('adminToken');
    const exp = parseInt(localStorage.getItem('adminExpiresAt') || '0', 10);
    if (token && Date.now() < exp) nav('/admin', { replace: true });
    return () => { m.remove(); };
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await axios.post(`${API}/login`, { password });
      localStorage.setItem('adminToken', r.data.token);
      localStorage.setItem('adminExpiresAt', String(Date.now() + r.data.expires_in * 1000));
      nav('/admin', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-[#1a1a1a] border-gray-800 shadow-2xl">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Lock className="w-5 h-5 text-[#FF6600]" /> Admin Access
          </CardTitle>
          <p className="text-gray-500 text-sm mt-1">Powerlab Works tuning database management</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-black/50 border-gray-700 text-white h-11"
              autoFocus
              data-testid="admin-password-input"
            />
            {error && (
              <div className="flex items-center gap-2 text-sm text-red-400" data-testid="admin-login-error">
                <AlertCircle className="w-4 h-4 flex-shrink-0" /> {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading || !password}
              className="w-full bg-[#FF6600] hover:bg-[#E55A00] text-white h-11"
              data-testid="admin-login-btn"
            >
              {loading ? <Loader2 className="animate-spin w-4 h-4" /> : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
